import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { ChecklistTask, CreateChecklistTaskInput } from '@nx/domain';
import { asyncStatusReducers, initialAsyncStatus } from './asyncStatus';

const checklistSlice = createSlice({
  name: 'checklist',
  initialState: {
    items: [] as ChecklistTask[],
    ...initialAsyncStatus,
  },
  reducers: {
    checklistWatchRequested(_state, _action: PayloadAction<string>) {},
    checklistLoaded(state, action: PayloadAction<ChecklistTask[]>) {
      state.items = action.payload;
      asyncStatusReducers.resolveLoaded(state);
    },
    checklistTaskCreateRequested(
      state,
      _action: PayloadAction<{ eventId: string; input: CreateChecklistTaskInput }>,
    ) {
      asyncStatusReducers.markSaving(state);
    },
    checklistTaskUpdateRequested(
      state,
      _action: PayloadAction<{
        eventId: string;
        taskId: string;
        input: Partial<CreateChecklistTaskInput>;
      }>,
    ) {
      asyncStatusReducers.markSaving(state);
    },
    checklistTemplateApplyRequested(
      _state,
      _action: PayloadAction<{ eventId: string; templateId: string }>,
    ) {},
    checklistSaveSucceeded(state) {
      asyncStatusReducers.resolveSaveSucceeded(state);
    },
    checklistFailed: asyncStatusReducers.resolveFailed,
  },
});

export const {
  checklistWatchRequested,
  checklistLoaded,
  checklistTaskCreateRequested,
  checklistTaskUpdateRequested,
  checklistTemplateApplyRequested,
  checklistSaveSucceeded,
  checklistFailed,
} = checklistSlice.actions;

export default checklistSlice.reducer;
